// src/components/Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Button from './Button';

const API_BASE = 'https://crtapp.xyz';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API_BASE}/api/check-auth`, { withCredentials: true })
      .then((res) => {
        const userRole = res.data.role;

        sessionStorage.setItem(
          'user',
          JSON.stringify({ role: userRole })
        );

        if (userRole === 'team_lead') {
          navigate('/team-lead');
        } else {
          navigate('/factory');
        }
      })
      .catch(() => {});
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(
        `${API_BASE}/api/login`,
        { username, password },
        { withCredentials: true }
      );

      const userRole = response.data.role;

      sessionStorage.setItem(
        'user',
        JSON.stringify({ role: userRole })
      );

      if (userRole === 'team_lead') {
        navigate('/team-lead');
      } else {
        navigate('/factory');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1>Login</h1>
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <form onSubmit={handleLogin}>
        <h3>User Login</h3>

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          disabled={loading}
          autoFocus
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={loading}
        />

        <Button type="submit" disabled={loading || !username || !password}>
          {loading ? 'Logging in…' : 'Login'}
        </Button>
      </form>
    </div>
  );
}

export default Login;